import React, { useState, useContext } from "react";
import { Dimensions, Text, ScrollView, Image, View, Button, StatusBar } from "react-native";
import { style_templates } from "../config_variables/styles";
import LotDetailRow from "../components/LotDetailRow";
import Timeline from "../components/Timeline";
import convertNumberToCurrency from "../utils/convertNumberToCurrency";
import { DataContext } from "../store/data-context"

function LotScreen({route, navigation}) {
  // console.log('lotdetails: ' + JSON.stringify(rec))
  // console.log('lotdetails.id: ' + JSON.stringify(rec.id))
      const dataCtx = useContext(DataContext);

  const rec = {...route.params.lotdetails}  

const master_contract_not_null = rec.LatestMasterContract__r != null ? true : false
const land_contract_not_null = rec.LatestMasterContract__r != null ? rec.LatestMasterContract__r.LandContract__r != null ? true : false :  false
const build_contract_not_null = rec.LatestMasterContract__r != null ? rec.LatestMasterContract__r.BuildContract__r != null ? true : false :  false
const property_contract_not_null = rec.LatestMasterContract__r != null ? rec.LatestMasterContract__r.PropertyContract__r != null ? true : false :  false
const house_design_not_null = rec.LatestMasterContract__r != null ? rec.LatestMasterContract__r.HouseDesign__r != null ? true : false :  false
const contract_lifecycle_not_null = rec.LatestMasterContract__r != null ? rec.LatestMasterContract__r.ContractLifecycle__r != null ? true : false :  false
const lot_address = rec.StreetNumber__c + ' , ' + rec.StreetName__c + ' , ' +  rec.Suburb__c + ' , ' +  rec.State__c  + ' , ' + rec.Postcode__c
  // console.log('master_contract_not_null: ' + master_contract_not_null)
const reservation_date= master_contract_not_null ? rec.LatestMasterContract__r.ContractReservationDate__c : ""

const land_price = master_contract_not_null ? rec.LatestMasterContract__r.LandContractPrice__c : 0
const build_price = master_contract_not_null ? rec.LatestMasterContract__r.BuildContractPrice__c : 0
const property_price = master_contract_not_null ? rec.LatestMasterContract__r.PropertyContractPrice__c : 0
const total_package_price = land_price + build_price + property_price

const land_val = master_contract_not_null  && land_contract_not_null ? rec.LatestMasterContract__r.LandContract__r.Valuation__c : 0
const build_val = master_contract_not_null && build_contract_not_null ? rec.LatestMasterContract__r.BuildContract__r.Valuation__c : 0
const property_val = master_contract_not_null && property_contract_not_null ? rec.LatestMasterContract__r.PropertyContract__r.Valuation__c : 0
const total_package_val = land_val + build_val + property_val

// const design_name = house_design_not_null ? rec.LatestMasterContract__r.HouseDesign__r.Name
// const design_name = house_design_not_null ? rec.LatestMasterContract__r.HouseDesign__r.Name

const land_status = master_contract_not_null ? rec.LatestMasterContract__r.LandContractStatus__c : 0
const build_status = master_contract_not_null ? rec.LatestMasterContract__r.BuildContractStatus__c : 0
const property_status = master_contract_not_null ? rec.LatestMasterContract__r.PropertyContractStatus__c : 0
const master_contract_status = rec.LatestMasterContract__r != null ? rec.LatestMasterContract__r.MasterContractStatus__c : ""

const lease_status = contract_lifecycle_not_null ? rec.LatestMasterContract__r.ContractLifecycle__r.LEAPLeaseStatus__c : ""
const leap_advertised_date = contract_lifecycle_not_null ? rec.LatestMasterContract__r.ContractLifecycle__r.LEAPAdvertisedDate__c : ""
const lease_start_date = contract_lifecycle_not_null ? rec.LatestMasterContract__r.ContractLifecycle__r.LEAPLeaseStartDate__c : ""
const lease_end_date = contract_lifecycle_not_null ? rec.LatestMasterContract__r.ContractLifecycle__r.LEAPLeaseEndDate__c : ""
const weekly_lease_amount = contract_lifecycle_not_null ? rec.LatestMasterContract__r.ContractLifecycle__r.LEAPWeeklyLeaseAmount__c : ""

const slab = contract_lifecycle_not_null ? rec.LatestMasterContract__r.ContractLifecycle__r.SlabStage__c : ""
const frame = contract_lifecycle_not_null ? rec.LatestMasterContract__r.ContractLifecycle__r.FrameStage__c : ""
const lockup = contract_lifecycle_not_null ? rec.LatestMasterContract__r.ContractLifecycle__r.LockUpStage__c: ""
const fix = contract_lifecycle_not_null ? rec.LatestMasterContract__r.ContractLifecycle__r.FixStage__c: ""
const final = contract_lifecycle_not_null ? rec.LatestMasterContract__r.ContractLifecycle__r.FinalStage__c : ""
const settlement = contract_lifecycle_not_null ? rec.LatestMasterContract__r.ContractLifecycle__r.SettlementStage__c : ""


const milestone_dates = {}

milestone_dates['land'] = master_contract_not_null && land_contract_not_null ? 
[ 
      {   
            status: 'Reserved', 
            date: rec.LatestMasterContract__r.ContractReservationDate__c
      }, 
      {   
            status: 'Contracted', 
            date: rec.LatestMasterContract__r.LandContract__r.DateSetContracted__c
      }, 
      {   
            status: 'Sold', 
            date: rec.LatestMasterContract__r.LandContract__r.DateSetSold__c
      }, 
      {   
            // status: 'Settled', 
            status: 'Land Settled', 
            date: rec.LatestMasterContract__r.LandContract__r.DateSetSettled__c
      }, 
            {   
            status: 'Build Settled', 
            date: build_contract_not_null ? rec.LatestMasterContract__r.BuildContract__r.DateSetSettled__c : rec.LatestMasterContract__r.BuildContract__r.PropertySetSettled__c
      }, 
] : []

// milestone_dates['build'] = master_contract_not_null && build_contract_not_null ? 
// [ 
//       {   
//             status: 'Reserved', 
//             date: rec.LatestMasterContract__r.ContractReservationDate__c
//       }, 
//       {   
//             status: 'Contracted', 
//             date: rec.LatestMasterContract__r.BuildContract__r.DateSetContracted__c
//       }, 
//       {   
//             status: 'Sold', 
//             date: rec.LatestMasterContract__r.BuildContract__r.DateSetSold__c
//       }, 
//       {   
//             status: 'Settled', 
//             date: rec.LatestMasterContract__r.BuildContract__r.DateSetSettled__c
//       }, 
// ] : []

// milestone_dates['property'] = master_contract_not_null && property_contract_not_null ? 
// [ 
//       {   
//             status: 'Reserved', 
//             date: rec.LatestMasterContract__r.ContractReservationDate__c
//       }, 
//       {   
//             status: 'Contracted', 
//             date: rec.LatestMasterContract__r.PropertyContract__r.DateSetContracted__c
//       }, 
//       {   
//             status: 'Sold', 
//             date: rec.LatestMasterContract__r.PropertyContract__r.DateSetSold__c
//       }, 
//       {   
//             status: 'Settled', 
//             date: rec.LatestMasterContract__r.PropertyContract__r.DateSetSettled__c
//       }, 
// ] : []

const construction_dates = [
      {
            stage: 'Slab',
            date: slab
      },
      {
            stage: 'Frame',
            date: frame
      },      
      {
            stage: 'Lockup',
            date: lockup
      },      
      {
            stage: 'Fix',
            date: fix
      },
      {
            stage: 'Final',
            date: final
      },
      {
            stage: 'Settlement',
            date: settlement
      },
      
      
      // slab, frame, lockup, fix, final, settlement
]

function backToLotsScreen() {
      navigation.navigate("Lots", {
            screendataarray: dataCtx.screenDataArray,
      });
}


// const milestone_dates = {
//       land: [
//             contracted: ,
//             sold: 
//             settled: ],
//       build: [2].
//       property: [3]
// }

      const construction_dates_null = construction_dates.reduce((ret_val, o) => o.date!= "" ? ret_val && false : ret_val && true, true) 
      console.log('construction_dates_null: ' + construction_dates_null)



  return (

      <View style={style_templates.app_container}>
      <View style={style_templates.app_body_container}>
        <StatusBar animated={true} backgroundColor="#61dafb" />
            <View style={[style_templates.app_sub_container_image_header, {flex: 2}]}>
                                          <Image
                              source={'https://resimaxgroup--c.documentforce.com/sfc/dist/version/download/?oid=00D7F000006kPQU&ids=0687F00000ykHiB&d=%2Fa%2F7F000000UbwB%2FtZrJziqm5rY20Bq3POQF42hUoGuaRs4qWpze3eD_U2Q&asPdf=false'}
                              style={style_templates.ImageOnHeaderStyle}
                        />
            </View>
            <View style={[style_templates.app_sub_container_lot_details, {flex:10}]}>
                  <ScrollView showsVerticalScrollIndicator={false} >
                        {/* <LotDetailRow key={rec.Id * Math.random()} value={rec.Id} name={"Id"} icon={"car"}></LotDetailRow> */}

                        <View style={style_templates.lot_detail_page_section_header}>
                              LOT DETAILS
                        </View>
                        <View style={style_templates.lot_detail_template_text_container}>
                              <View style={style_templates.screen4_row_container}>
                                          <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Lot Number"} value={rec.Name} ></LotDetailRow>
                              </View>
                              <View style={style_templates.screen4_row_container}>
                                    <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Tranche"} value={rec.Trancher__c} ></LotDetailRow>
                              </View>
                              <View style={style_templates.screen4_row_container}>
                                    <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Build Type"} value={rec.MasterContractType__c} ></LotDetailRow>
                              </View>                        
                              <View style={style_templates.screen4_row_container}>
                                    <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Status"} value={rec.StatusDevr__c} ></LotDetailRow>
                              </View>
                              <View style={style_templates.screen4_row_container}>
                                    <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Current Milestone"} value={rec.Milestone__c} ></LotDetailRow>
                              </View>
                        </View>

                        <View style={style_templates.lot_detail_page_section_header}>
                              PROJECT DETAILS
                        </View>
                        <View style={style_templates.lot_detail_template_text_container}>
                              <View style={style_templates.screen4_row_container}>
                                    <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Project"} value={rec.Project__r.Name} ></LotDetailRow>
                              </View>
                              <View style={style_templates.screen4_row_container}>
                                    <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Stage"} value={rec.Stage__r.Name} ></LotDetailRow>
                              </View>                        
                              <View style={style_templates.screen4_row_container}>
                                    <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Address"} value={lot_address} ></LotDetailRow>
                              </View>                           
                        </View>

                  <View style={style_templates.lot_detail_page_section_header}>
                        LAND SPECS
                  </View>

                  <View style={style_templates.lot_detail_template_text_container}>
                              <View style={style_templates.screen4_row_container}>
                                    <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Land Depth"} value={rec.LandDepth__c} ></LotDetailRow>
                              </View>
                              <View style={style_templates.screen4_row_container}>
                                    <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Land Frontage"} value={rec.LandFrontage__c} ></LotDetailRow>
                              </View>                        
                              <View style={style_templates.screen4_row_container}>
                                    <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Corner Lot"} value={rec.IsCornerLot__c} ></LotDetailRow>
                              </View>                 
                              <View style={style_templates.screen4_row_container}>
                                    <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Irregular Lot"} value={rec.IsIrregularLot__c} ></LotDetailRow>
                              </View>                             
                  </View>

                  <View style={style_templates.lot_detail_page_section_header}>
                        BUILD SPECS
                  </View>

                  <View style={style_templates.lot_detail_template_text_container}>
                              <View style={style_templates.screen4_row_container}>
                                    <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Land Depth"} value={rec.LandDepth__c} ></LotDetailRow>
                              </View>
                              <View style={style_templates.screen4_row_container}>
                                    <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Land Frontage"} value={rec.LandFrontage__c} ></LotDetailRow>
                              </View>                        
                              <View style={style_templates.screen4_row_container}>
                                    <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Corner Lot"} value={rec.IsCornerLot__c} ></LotDetailRow>
                              </View>                 
                              <View style={style_templates.screen4_row_container}>
                                    <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Irregular Lot"} value={rec.IsIrregularLot__c} ></LotDetailRow>
                              </View>                             
                  </View>


                  <View style={style_templates.lot_detail_page_section_header}>
                        PRICES
                  </View>

                  <View style={style_templates.lot_detail_template_text_container}>
                              <View style={style_templates.screen4_row_container}>
                                    <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Land Price"} value={convertNumberToCurrency(land_price)} ></LotDetailRow>
                              </View>
                              <View style={style_templates.screen4_row_container}>
                                    <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Build Price"} value={convertNumberToCurrency(build_price)} ></LotDetailRow>
                              </View>                        
                              { master_contract_not_null && property_contract_not_null && (                        
                                    <View style={style_templates.screen4_row_container}>
                                          <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Property Price"} value={convertNumberToCurrency(property_price)} ></LotDetailRow>
                                    </View>                 
                              )}
                              <View style={style_templates.screen4_row_container}>
                                    <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Package Price"} value={convertNumberToCurrency(total_package_price)} ></LotDetailRow>
                              </View>                             
                  </View>


                  <View style={style_templates.lot_detail_page_section_header}>
                        VALUATION
                  </View>

                  <View style={style_templates.lot_detail_template_text_container}>
                              <View style={style_templates.screen4_row_container}>
                                    <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Land Val"} value={convertNumberToCurrency(land_val)} diff={land_val-land_price}></LotDetailRow>                             
                                    {/* <Icon2 name="chevron-down" size={iconSize} color="#f08080" /> */}
                                    {/* <Icon2 name={land_val > land_price ? "chevron-up" : "chevron-down"}  size={iconSize} color="#f08080" /> */}
                              </View>
                              <View style={style_templates.screen4_row_container}>
                                    <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Build Val"} value={convertNumberToCurrency(build_val)} diff={build_val-build_price}></LotDetailRow>
                              </View>                        
                              { master_contract_not_null && property_contract_not_null && (                        
                                    <View style={style_templates.screen4_row_container}>
                                          <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Property Val"} value={convertNumberToCurrency(property_val)} diff={property_val-property_price}></LotDetailRow>
                                    </View>                 
                              )}
                              <View style={style_templates.screen4_row_container}>
                                    <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Total Val"} value={convertNumberToCurrency(total_package_val)}  diff={total_package_val-total_package_price}></LotDetailRow>
                              </View>                             
                  </View>


                  <View style={style_templates.lot_detail_page_section_header}>
                        STATUS SUMMARY
                  </View>

                  <View style={style_templates.lot_detail_template_text_container}>
                              <View style={style_templates.screen4_row_container}>
                                    <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Land status"} value={land_status} ></LotDetailRow>
                              </View>
                              <View style={style_templates.screen4_row_container}>
                                    <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Build status"} value={build_status} ></LotDetailRow>
                              </View>
                              { master_contract_not_null && property_contract_not_null && (
                                    <View style={style_templates.screen4_row_container}>
                                          <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Property status"} value={property_status} ></LotDetailRow>
                                    </View>                 
                              )}
                              <View style={style_templates.screen4_row_container}>
                                    <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Package status"} value={master_contract_status} ></LotDetailRow>
                              </View>                             
                  </View>
                  <View style={style_templates.lot_detail_page_section_header}>
                        SUBDIVISION DETAILS
                  </View>
                  <View style={style_templates.lot_detail_template_text_container}>
                              <View style={style_templates.screen4_row_container}>
                                    <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Volume"} value={rec.Volume__c} ></LotDetailRow>
                              </View>
                              <View style={style_templates.screen4_row_container}>
                                    <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Folio"} value={rec.FolioNo__c} ></LotDetailRow>
                              </View>                        
                              <View style={style_templates.screen4_row_container}>
                                    <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Municipality"} value={rec.Municipality__c} ></LotDetailRow>
                              </View>                 
                              <View style={style_templates.screen4_row_container}>
                                    <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"LP"} value={rec.LP__c} ></LotDetailRow>
                              </View>                             
                              <View style={style_templates.screen4_row_container}>
                                    <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"PS"} value={rec.PS__c} ></LotDetailRow>
                              </View>                                                     
                              <View style={style_templates.screen4_row_container}>
                                    <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Project Vendor"} value={rec.ProjectVendor__c} ></LotDetailRow>
                              </View>                                                                             
                  </View>

                  <View style={style_templates.lot_detail_page_section_header}>
                        <Text>LEAP DETAILS</Text>
                  </View>

                  <View style={style_templates.lot_detail_template_text_container}>
                              <View style={style_templates.screen4_row_container}>
                                    <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Lease Status"} value={lease_status} ></LotDetailRow>
                              </View>
                              <View style={style_templates.screen4_row_container}>
                                    <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Advertised Date"} value={leap_advertised_date} ></LotDetailRow>
                              </View>                        
                              <View style={style_templates.screen4_row_container}>
                                    <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Lease Start Date"} value={lease_start_date} ></LotDetailRow>
                              </View>                 
                              <View style={style_templates.screen4_row_container}>
                                    <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Lease End Date"} value={lease_end_date} ></LotDetailRow>
                              </View>                             
                              <View style={style_templates.screen4_row_container}>
                                    <LotDetailRow key={rec.Id * Math.random()}  icon={""} name={"Lease Amount"} value={convertNumberToCurrency(weekly_lease_amount)} ></LotDetailRow>
                              </View>    
                  </View>


                  <View style={style_templates.lot_detail_page_section_header}>
                        <Text>CONTRACT STATUS TIMELINE</Text>
                  </View>

                  <View style={style_templates.timeline_container} >
                        <Timeline type="status" dates={milestone_dates['land']}></Timeline>
                  </View>


      {/*
                  <View style={style_templates.lot_detail_page_section_header}>
                        <Text>TIMELINE - BUILD CONTRACT</Text>
                  </View>

                  <View style={style_templates.lot_detail_template_text_container} >
                        <Timeline type="status" dates={milestone_dates['build']}></Timeline>
                  </View>

            { master_contract_not_null && property_contract_not_null && (
                        <>
                              <View style={style_templates.lot_detail_page_section_header}>
                                    <Text>      TIMELINE - PROPERTY CONTRACT</Text>
                                    </View>

                              <View style={style_templates.lot_detail_template_text_container}>
                                          <Timeline type="status" dates={milestone_dates['proeprty']}></Timeline>
                              </View>
                        </>
                  )} */}

                  <View style={style_templates.lot_detail_page_section_header}>
                        <Text>CLAIMS TIMELINE </Text>
                  </View>

                  {/* { !construction_dates_null && ( */}
                        <View style={style_templates.timeline_container}>
                              <Timeline type="construction" dates={construction_dates}></Timeline>
                        </View>
                  {/* )} */}



                  {/* <Text>{rec.LandSize__c}</Text>
                  <Text>{rec.LandSize_r__c}</Text>
                  <Text>{rec.Price__c}</Text>

            

                  <Text>{rec.JobCodeconsolidated__c}</Text>

                  { 
                  master_contract_not_null && house_design_not_null  &&
                  <Text>{rec.LatestMasterContract__r.HouseDesign__r.TotalSizeInM2__c}</Text>
                  }

                  { 
                  master_contract_not_null && land_contract_not_null  &&
                  <>
                  <Text>{rec.LatestMasterContract__r.LandContract__r.DateSetContracted__c}</Text>
                  <Text>{rec.LatestMasterContract__r.LandContract__r.DateSetSold__c}</Text>
                  <Text>{rec.LatestMasterContract__r.LandContract__r.DateSetSettled__c}</Text>
                  <Text>{rec.LatestMasterContract__r.LandContract__r.Valuation__c}</Text>
                  <Text>{rec.LatestMasterContract__r.LandContract__r.ValDifference__c}</Text>
                  </>
                  }

                  { 
                  master_contract_not_null && build_contract_not_null  &&
                  <>
                  <Text>{rec.LatestMasterContract__r.BuildContract__r.DateSetContracted__c}</Text>
                  <Text>{rec.LatestMasterContract__r.BuildContract__r.DateSetSold__c}</Text>
                  <Text>{rec.LatestMasterContract__r.BuildContract__r.DateSetSettled__c}</Text>
                  <Text>{rec.LatestMasterContract__r.BuildContract__r.Valuation__c}</Text>
                  <Text>{rec.LatestMasterContract__r.BuildContract__r.ValDifference__c}</Text>
                  </>
                  }

                  { 
                  master_contract_not_null && property_contract_not_null  &&
                  <>
                  <Text>{rec.LatestMasterContract__r.PropertyContract__r.DateSetContracted__c}</Text>
                  <Text>{rec.LatestMasterContract__r.PropertyContract__r.DateSetSold__c}</Text>
                  <Text>{rec.LatestMasterContract__r.PropertyContract__r.DateSetSettled__c}</Text>
                  <Text>{rec.LatestMasterContract__r.PropertyContract__r.Valuation__c}</Text>
                  <Text>{rec.LatestMasterContract__r.PropertyContract__r.ValDifference__c}</Text>
                  </>
                  }

                  { 
                  master_contract_not_null && contract_lifecycle_not_null  &&
                  <>
                  <Text>{rec.LatestMasterContract__r.ContractLifecycle__r.SlabStage__c}</Text>
                  <Text>{rec.LatestMasterContract__r.ContractLifecycle__r.FrameStage__c}</Text>
                  <Text>{rec.LatestMasterContract__r.ContractLifecycle__r.LockUpStage__c}</Text>
                  <Text>{rec.LatestMasterContract__r.ContractLifecycle__r.FixStage__c}</Text>
                  <Text>{rec.LatestMasterContract__r.ContractLifecycle__r.FinalStage__c}</Text>
                  <Text>{rec.LatestMasterContract__r.ContractLifecycle__r.SettlementStage__c}</Text>
                  </>
                  }   */}
                  </ScrollView>
            </View>
            <View style={[style_templates.bottom_nav_bar, {flex:1}]}>
                  <View style={{marginLeft:140,marginRight:140}}>
                        {/* <Button onPress={() => {console.log('pressed back button')}} title="Back"></Button> */}
                        <Button onPress={backToLotsScreen} title="Close"></Button>
                  </View>
            </View>                  
      </View>
    </View>
  );
}

export default LotScreen;

